import { render, staticRenderFns } from "./mcDetail.vue?vue&type=template&id=050b620a&scoped=true"
import script from "./mcDetail.vue?vue&type=script&lang=js"
export * from "./mcDetail.vue?vue&type=script&lang=js"
import style0 from "./mcDetail.vue?vue&type=style&index=0&id=050b620a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050b620a",
  null
  
)

export default component.exports